<template>
  <b-container class="container--max-610">
    <div class="px-4">
      <div class="c-topbar-content c-topbar-content--compensate-borders">
        <div class="c-topbar-content__left">
          <mtg-header-link></mtg-header-link>
        </div>
        <div class="c-topbar-content__right"></div>
      </div>
    </div>
  </b-container>
</template>
<script>
import MtgHeaderLink from "./MtgHeaderLink";

export default {
  name: "MtgHeader",
  components: {
    MtgHeaderLink
  }
};
</script>
